'use client';

import { forwardRef, type ElementRef, type ComponentPropsWithoutRef } from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { cl } from 'utils/classnames';

const RadixPopover = PopoverPrimitive.Root;

RadixPopover.displayName = PopoverPrimitive.Root.displayName;

const RadixPopoverTrigger = PopoverPrimitive.Trigger;

const RadixPopoverContent = forwardRef<ElementRef<typeof PopoverPrimitive.Content>, ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>>(
  ({ className, align = 'center', sideOffset = 4, ...props }, ref) => (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={cl(
          'z-[100] origin-[--radix-popover-content-transform-origin] border border-transparent bg-clear p-5 text-copy shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
          className,
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  ),
);
RadixPopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { RadixPopover, RadixPopoverTrigger, RadixPopoverContent };
